import React, { useState } from 'react';
import { Link as LinkR } from 'react-router-dom';
import { Link as LinkS } from 'react-scroll';
import Logo from '../../images/logo.png';
import './Navbar.css';


const Navbar = () => {

    const [click, setClick] = useState(false);


    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);
    return (
        <>
            {/* <!-- Navigation --> */}
            <div className="Navigation" id='navbar'>
                <div className="container nav">
                    <div className="nav__brand">
                        <LinkR to='/'> <img src={Logo} alt='retcon' /> </LinkR>
                    </div>

                    <div className="nav__nav">
                        <div className="nav__link">
                            <ul>
                                <li><LinkS to='showcase' smooth={true} duration={1000}>Home</LinkS></li>
                                <li><LinkS to='about' smooth={true} duration={1000}>About</LinkS></li>
                                <li><LinkS to='services' smooth={true} duration={1000}>Services</LinkS></li>
                                <li><LinkS to='choose' smooth={true} duration={1000}>Why us</LinkS></li>
                                <li><LinkS to='contact' smooth={true} duration={1000}>Contact</LinkS></li>
                            </ul>

                            <div className="nav__button">
                                <a href="tel:+250780257333">Get in Touch</a>
                            </div>
                        </div>

                    </div>

                    <div className='nav__menu' onClick={handleClick}>
                        <i className={click ? 'fas fa-times' : 'fas fa-align-right'}></i>
                    </div>
                </div>
                {/* SideDrawer */}
                <ul className={click ? 'sidedrawerActive' : 'sidedrawerClose'}>
                    <li className='sideDrawerLinks'><LinkS to='showcase' smooth={true} duration={1000} onClick={closeMobileMenu}>Home</LinkS></li>
                    <li className='sideDrawerLinks'><LinkS to='about' smooth={true} duration={1000} onClick={closeMobileMenu}>About</LinkS></li>
                    <li className='sideDrawerLinks'><LinkS to='services' smooth={true} duration={1000} onClick={closeMobileMenu}>Services</LinkS></li>
                    <li className='sideDrawerLinks'><LinkS to='choose' smooth={true} duration={1000} onClick={closeMobileMenu}>Why us</LinkS></li>
                    <li className='sideDrawerLinks'><LinkS to='contact' smooth={true} duration={1000} onClick={closeMobileMenu}>Contact</LinkS></li>
                    <div className="sideDrawer__button">
                        <a href="tel:+250780257333">Get in Touch</a>
                    </div>
                </ul>
                {/* SideDrawer */}
            </div>
            {/* <!-- End of Navigation --> */}
        </>
    )
}

export default Navbar
